import { ComponentStyleConfig } from '@chakra-ui/react';

const Checkbox: ComponentStyleConfig = {
  variants: {
    'retreats-filter': {
      control: {
        borderWidth: '1px',
        borderRadius: '5px',
        borderColor: 'neutral.400',
        _focus: {
          outline: 'none',
          boxShadow: 'none'
        },
        _checked: {
          background: 'neutral.700',
          borderColor: 'neutral.700',
          _hover: { background: 'neutral.700', borderColor: 'neutral.700' }
        }
      },
      label: {
        width: '100%'
      }
    },
    resources: {
      control: {
        width: { base: '20px', lg: '26px' },
        height: { base: '20px', lg: '26px' },
        borderWidth: { base: 1, lg: 2 },
        borderRadius: '4px',
        borderColor: 'teal.500',
        _focus: {
          outline: 'none',
          boxShadow: 'none'
        },
        _checked: {
          background: 'teal.500',
          borderColor: 'teal.500',
          _hover: { background: 'teal.500', borderColor: 'teal.500' }
        }
      },
      label: {
        width: '100%',
        fontSize: { base: 12, lg: 20 }
      }
    }
  }
};

export default Checkbox;
